const SITE = "Probably True";
const DEFAULT_DESC = "De wiki waarop je inzet op de waarheid.";

function upsert(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Update description + Open Graph + Twitter meta tags dynamically.
export function setMeta({ title, description, url } = {}) {
  const ogTitle = title ? `${title} — ${SITE}` : SITE;
  const desc = (description && description.trim()) || DEFAULT_DESC;
  upsert("name", "description", desc);
  upsert("property", "og:title", ogTitle);
  upsert("property", "og:description", desc);
  upsert("property", "og:type", "website");
  upsert("property", "og:site_name", SITE);
  upsert("property", "og:url", url || window.location.href);
  upsert("name", "twitter:card", "summary_large_image");
  upsert("name", "twitter:title", ogTitle);
  upsert("name", "twitter:description", desc);
}
